import { render, staticRenderFns } from "./i-invoice-form.vue?vue&type=template&id=4c37c52b&scoped=true"
import script from "./i-invoice-form.vue?vue&type=script&lang=js"
export * from "./i-invoice-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c37c52b",
  null
  
)

export default component.exports